import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IReembolsoConfirmarForm } from "../../../../types/agendamento";

export const useConfirmarReembolsoAgendamento = () => {
  return useMutation({
    mutationFn: (data: IReembolsoConfirmarForm) =>
      Agendamento.confirmarReembolso(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
